// import React from "react";
// import { BiNews, BiVideo, BiTrendingDown } from "react-icons/bi";
// import { FiEye, FiTrendingUp, FiUsers, FiFileText } from "react-icons/fi";
// import { useQuery } from "@tanstack/react-query";
// import { apiRequest } from "../store/api/api";
// import useAuthToken from "../Hooks/useAuthToken";

// // Modern Stats Card Component
// const ModernStatsCard = ({
//   title,
//   value,
//   percentage,
//   icon: Icon,
//   gradient,
//   trend,
// }) => (
//   <div className="modern-stats-card" style={{ background: gradient }}>
//     <div className="stats-icon">
//       <Icon size={28} />
//     </div>
//     <div className="stats-content">
//       <p className="stats-title">{title}</p>
//       <h3 className="stats-value">{value}</h3>
//       <div className="stats-footer">
//         <span className={`trend ${trend >= 0 ? "trend-up" : "trend-down"}`}>
//           {trend >= 0 ? (
//             <FiTrendingUp size={14} />
//           ) : (
//             <BiTrendingDown size={14} />
//           )}
//           {percentage}%
//         </span>
//         <span className="stats-period">vs last period</span>
//       </div>
//     </div>
//   </div>
// );

// // Modern Table Card
// const ModernTableCard = ({ title, data, type }) => (
//   <div className="glass-card">
//     <div className="card-header-modern">
//       <h5 className="card-title-modern">{title}</h5>
//       <div className="card-badge">{data?.length || 0} items</div>
//     </div>
//     <div className="table-container-modern">
//       {data && data.length > 0 ? (
//         <div className="modern-list">
//           {data.map((item, index) => (
//             <div key={item._id || index} className="modern-list-item">
//               <div className="item-index">{index + 1}</div>
//               {item.image && (
//                 <img src={item.image} alt={item.title} className="item-image" />
//               )}
//               <div className="item-content">
//                 <h6 className="item-title">
//                   {item.title || item.reporterEmail}
//                 </h6>
//                 <p className="item-subtitle">
//                   {type === "news" &&
//                     `${item.visitor?.toLocaleString()} views • ${
//                       item.categoryList?.[0]?.name || "News"
//                     }`}
//                   {type === "video" &&
//                     new Date(item.createdAt).toLocaleDateString()}
//                   {type === "reporter" &&
//                     `${
//                       item.postsCount
//                     } posts • ${item.totalVisitors?.toLocaleString()} views`}
//                 </p>
//               </div>
//               {type === "reporter" && (
//                 <div className="item-stats">
//                   <span className="stat-badge primary">{item.postsCount}</span>
//                   <span className="stat-badge success">
//                     {Math.round(item.totalVisitors / item.postsCount)}
//                   </span>
//                 </div>
//               )}
//             </div>
//           ))}
//         </div>
//       ) : (
//         <div className="empty-state">
//           <FiFileText size={48} />
//           <p>No data available</p>
//         </div>
//       )}
//     </div>
//   </div>
// );

// // Simple Line Chart Component
// const SimpleLineChart = ({ title, labels, dataPoints, color }) => {
//   if (!dataPoints || dataPoints.length === 0) {
//     return (
//       <div>
//         <h5 className="card-title-modern" style={{ marginBottom: "1.5rem" }}>
//           {title}
//         </h5>
//         <div className="empty-state">
//           <p>No data available</p>
//         </div>
//       </div>
//     );
//   }

//   const maxValue = Math.max(...dataPoints);
//   const minValue = Math.min(...dataPoints);
//   const range = maxValue - minValue || 1;

//   return (
//     <div>
//       <h5 className="card-title-modern" style={{ marginBottom: "1.5rem" }}>
//         {title}
//       </h5>
//       <div style={{ height: "200px", position: "relative" }}>
//         <svg width="100%" height="100%" style={{ overflow: "visible" }}>
//           <polyline
//             fill="none"
//             stroke={color}
//             strokeWidth="3"
//             points={dataPoints
//               .map((value, index) => {
//                 const x = (index / (dataPoints.length - 1)) * 100;
//                 const y = 100 - ((value - minValue) / range) * 80;
//                 return `${x}%,${y}%`;
//               })
//               .join(" ")}
//           />
//           {dataPoints.map((value, index) => {
//             const x = (index / (dataPoints.length - 1)) * 100;
//             const y = 100 - ((value - minValue) / range) * 80;
//             return (
//               <circle
//                 key={index}
//                 cx={`${x}%`}
//                 cy={`${y}%`}
//                 r="4"
//                 fill={color}
//               />
//             );
//           })}
//         </svg>
//       </div>
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           marginTop: "1rem",
//           fontSize: "0.8rem",
//           color: "#718096",
//         }}
//       >
//         {labels.map((label, index) => (
//           <span key={index}>{label}</span>
//         ))}
//       </div>
//     </div>
//   );
// };

// // Donut Chart Component
// const SimpleDonutChart = ({ data, labels, colors }) => {
//   if (!data || data.length === 0) {
//     return (
//       <div>
//         <h5 className="card-title-modern" style={{ marginBottom: "1.5rem" }}>
//           Posts by Category
//         </h5>
//         <div className="empty-state">
//           <p>No data available</p>
//         </div>
//       </div>
//     );
//   }

//   const total = data.reduce((sum, val) => sum + val, 0);
//   let currentAngle = -90;

//   return (
//     <div>
//       <h5 className="card-title-modern" style={{ marginBottom: "1.5rem" }}>
//         Posts by Category
//       </h5>
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "center",
//           marginBottom: "1.5rem",
//         }}
//       >
//         <svg width="200" height="200" viewBox="0 0 200 200">
//           {data.map((value, index) => {
//             const percentage = (value / total) * 100;
//             const angle = (percentage / 100) * 360;
//             const startAngle = currentAngle;
//             const endAngle = currentAngle + angle;
//             currentAngle = endAngle;

//             const startRad = (startAngle * Math.PI) / 180;
//             const endRad = (endAngle * Math.PI) / 180;

//             const x1 = 100 + 80 * Math.cos(startRad);
//             const y1 = 100 + 80 * Math.sin(startRad);
//             const x2 = 100 + 80 * Math.cos(endRad);
//             const y2 = 100 + 80 * Math.sin(endRad);

//             const largeArc = angle > 180 ? 1 : 0;

//             return (
//               <path
//                 key={index}
//                 d={`M 100 100 L ${x1} ${y1} A 80 80 0 ${largeArc} 1 ${x2} ${y2} Z`}
//                 fill={colors[index % colors.length]}
//               />
//             );
//           })}
//           <circle cx="100" cy="100" r="50" fill="white" />
//           <text
//             x="100"
//             y="95"
//             textAnchor="middle"
//             fontSize="20"
//             fontWeight="bold"
//             fill="#2d3748"
//           >
//             {total}
//           </text>
//           <text
//             x="100"
//             y="115"
//             textAnchor="middle"
//             fontSize="12"
//             fill="#718096"
//           >
//             Total
//           </text>
//         </svg>
//       </div>
//       <div
//         style={{
//           display: "flex",
//           flexWrap: "wrap",
//           gap: "1rem",
//           justifyContent: "center",
//         }}
//       >
//         {labels.map((label, index) => (
//           <div
//             key={index}
//             style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
//           >
//             <div
//               style={{
//                 width: "12px",
//                 height: "12px",
//                 borderRadius: "3px",
//                 backgroundColor: colors[index % colors.length],
//               }}
//             />
//             <span style={{ fontSize: "0.85rem", color: "#4a5568" }}>
//               {label}
//             </span>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// function Dashboard() {
//   const token = useAuthToken();

//   // Fetch Dashboard Stats
//   const {
//     data: dashboardData,
//     isLoading: isDashboardLoading,
//     error: dashboardError,
//   } = useQuery({
//     queryKey: ["dashboard-stats"],
//     queryFn: () => apiRequest("get", "/api/dashboard/stats", null, token || ""),
//     enabled: !!token,
//   });

//   // Fetch Visitor Trends
//   const { data: visitorTrendsData, isLoading: isTrendsLoading } = useQuery({
//     queryKey: ["visitor-trends"],
//     queryFn: () =>
//       apiRequest(
//         "get",
//         "/api/dashboard/visitor-trends?period=7",
//         null,
//         token || ""
//       ),
//     enabled: !!token,
//   });

//   // Fetch Top Reporters
//   const { data: topReportersData, isLoading: isReportersLoading } = useQuery({
//     queryKey: ["top-reporters"],
//     queryFn: () =>
//       apiRequest("get", "/api/dashboard/top-reporters", null, token || ""),
//     enabled: !!token,
//   });

//   // Extract data from responses
//   const stats = dashboardData?.data || {};
//   const overview = stats?.overview || {};
//   const todayStats = stats?.todayStats || {};
//   const newsTypes = stats?.newsTypes || {};
//   const topVisitorNews = stats?.topVisitorNews || [];
//   const recentPosts = stats?.recentPosts || {};
//   const categoryWiseCount = stats?.categoryWiseCount || [];

//   const visitorTrends = visitorTrendsData?.data || [];
//   const topReporters = topReportersData?.data || [];

//   // Prepare data for charts
//   const trendLabels = visitorTrends.map((item) => {
//     const date = new Date(item.date);
//     return date.toLocaleDateString("en-US", { month: "short", day: "numeric" });
//   });
//   const trendVisitors = visitorTrends.map((item) => item.totalVisitors);
//   const trendPosts = visitorTrends.map((item) => item.postsCount);

//   // Category Chart Data
//   const categoryLabels = categoryWiseCount.map((item) => item.categoryName);
//   const categoryData = categoryWiseCount.map((item) => item.count);
//   const categoryColors = [
//     "#667eea",
//     "#764ba2",
//     "#f093fb",
//     "#4facfe",
//     "#00f2fe",
//     "#43e97b",
//     "#fa709a",
//     "#fee140",
//   ];

//   // Calculate percentage
//   const calculatePercentage = (current, total) => {
//     if (!total) return "0";
//     return ((current / total) * 100).toFixed(1);
//   };

//   if (isDashboardLoading || isTrendsLoading || isReportersLoading) {
//     return (
//       <div className="dashboard-container min-vh-100 d-flex align-items-center justify-content-center bg-light">
//         <div className="loading-state text-center">
//           <div
//             className="loading-spinner spinner-border text-primary mb-3"
//             role="status"
//             style={{ width: "4rem", height: "4rem" }}
//           >
//             <span className="visually-hidden">Loading...</span>
//           </div>
//           <p className="text-secondary fs-5 mb-0">Loading dashboard...</p>
//         </div>
//       </div>
//     );
//   }

//   if (dashboardError) {
//     return (
//       <div className="dashboard-container">
//         <div className="error-state">
//           <h4>⚠️ Error loading dashboard</h4>
//           <p>{dashboardError.message}</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="dashboard-container">
//       <style>{`
//         .dashboard-container {
//           padding: 2rem;
//           background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//           min-height: 100vh;
//         }

//         .dashboard-header {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           margin-bottom: 2rem;
//         }

//         .dashboard-title {
//           color: white;
//           font-size: 2rem;
//           font-weight: 700;
//           margin: 0;
//           text-shadow: 0 2px 10px rgba(0,0,0,0.2);
//         }

//         .stats-grid {
//           display: grid;
//           grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
//           gap: 1.5rem;
//           margin-bottom: 2rem;
//         }

//         .modern-stats-card {
//           padding: 1.5rem;
//           border-radius: 20px;
//           backdrop-filter: blur(10px);
//           border: 1px solid rgba(255, 255, 255, 0.2);
//           box-shadow: 0 8px 32px rgba(0,0,0,0.1);
//           transition: all 0.3s ease;
//           position: relative;
//           overflow: hidden;
//         }

//         .modern-stats-card::before {
//           content: '';
//           position: absolute;
//           top: 0;
//           left: 0;
//           right: 0;
//           bottom: 0;
//           background: rgba(255, 255, 255, 0.1);
//           opacity: 0;
//           transition: opacity 0.3s ease;
//         }

//         .modern-stats-card:hover {
//           transform: translateY(-5px);
//           box-shadow: 0 12px 40px rgba(0,0,0,0.15);
//         }

//         .modern-stats-card:hover::before {
//           opacity: 1;
//         }

//         .stats-icon {
//           width: 56px;
//           height: 56px;
//           background: rgba(255, 255, 255, 0.2);
//           border-radius: 16px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           color: white;
//           margin-bottom: 1rem;
//         }

//         .stats-content {
//           position: relative;
//           z-index: 1;
//         }

//         .stats-title {
//           color: rgba(255, 255, 255, 0.9);
//           font-size: 0.9rem;
//           margin: 0 0 0.5rem 0;
//           font-weight: 500;
//         }

//         .stats-value {
//           color: white;
//           font-size: 2rem;
//           font-weight: 700;
//           margin: 0 0 0.75rem 0;
//         }

//         .stats-footer {
//           display: flex;
//           align-items: center;
//           gap: 0.5rem;
//         }

//         .trend {
//           display: flex;
//           align-items: center;
//           gap: 0.25rem;
//           padding: 0.25rem 0.75rem;
//           border-radius: 20px;
//           font-size: 0.85rem;
//           font-weight: 600;
//         }

//         .trend-up {
//           background: rgba(76, 175, 80, 0.2);
//           color: #a5d6a7;
//         }

//         .trend-down {
//           background: rgba(244, 67, 54, 0.2);
//           color: #ef9a9a;
//         }

//         .stats-period {
//           color: rgba(255, 255, 255, 0.7);
//           font-size: 0.85rem;
//         }

//         .charts-grid {
//           display: grid;
//           grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
//           gap: 1.5rem;
//           margin-bottom: 2rem;
//         }

//         .glass-card {
//           background: rgba(255, 255, 255, 0.95);
//           backdrop-filter: blur(10px);
//           border-radius: 20px;
//           padding: 1.5rem;
//           box-shadow: 0 8px 32px rgba(0,0,0,0.1);
//           border: 1px solid rgba(255, 255, 255, 0.3);
//           transition: all 0.3s ease;
//         }

//         .glass-card:hover {
//           transform: translateY(-5px);
//           box-shadow: 0 12px 40px rgba(0,0,0,0.15);
//         }

//         .card-header-modern {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           margin-bottom: 1.5rem;
//           padding-bottom: 1rem;
//           border-bottom: 2px solid #f0f0f0;
//         }

//         .card-title-modern {
//           font-size: 1.25rem;
//           font-weight: 700;
//           color: #2d3748;
//           margin: 0;
//         }

//         .card-badge {
//           background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//           color: white;
//           padding: 0.5rem 1rem;
//           border-radius: 20px;
//           font-size: 0.85rem;
//           font-weight: 600;
//         }

//         .table-container-modern {
//           max-height: 400px;
//           overflow-y: auto;
//         }

//         .table-container-modern::-webkit-scrollbar {
//           width: 6px;
//         }

//         .table-container-modern::-webkit-scrollbar-track {
//           background: #f1f1f1;
//           border-radius: 10px;
//         }

//         .table-container-modern::-webkit-scrollbar-thumb {
//           background: #667eea;
//           border-radius: 10px;
//         }

//         .modern-list {
//           display: flex;
//           flex-direction: column;
//           gap: 1rem;
//         }

//         .modern-list-item {
//           display: flex;
//           align-items: center;
//           gap: 1rem;
//           padding: 1rem;
//           background: #f8f9fa;
//           border-radius: 12px;
//           transition: all 0.3s ease;
//         }

//         .modern-list-item:hover {
//           background: #e9ecef;
//           transform: translateX(5px);
//         }

//         .item-index {
//           width: 32px;
//           height: 32px;
//           background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//           color: white;
//           border-radius: 50%;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-weight: 700;
//           font-size: 0.9rem;
//           flex-shrink: 0;
//         }

//         .item-image {
//           width: 60px;
//           height: 60px;
//           border-radius: 12px;
//           object-fit: cover;
//           flex-shrink: 0;
//         }

//         .item-content {
//           flex: 1;
//           min-width: 0;
//         }

//         .item-title {
//           font-size: 0.95rem;
//           font-weight: 600;
//           color: #2d3748;
//           margin: 0 0 0.25rem 0;
//           overflow: hidden;
//           text-overflow: ellipsis;
//           white-space: nowrap;
//         }

//         .item-subtitle {
//           font-size: 0.85rem;
//           color: #718096;
//           margin: 0;
//         }

//         .item-stats {
//           display: flex;
//           gap: 0.5rem;
//           flex-shrink: 0;
//         }

//         .stat-badge {
//           padding: 0.35rem 0.75rem;
//           border-radius: 20px;
//           font-size: 0.85rem;
//           font-weight: 600;
//         }

//         .stat-badge.primary {
//           background: #e3f2fd;
//           color: #1976d2;
//         }

//         .stat-badge.success {
//           background: #e8f5e9;
//           color: #388e3c;
//         }

//         .empty-state {
//           text-align: center;
//           padding: 3rem;
//           color: #718096;
//         }

//         .empty-state svg {
//           color: #cbd5e0;
//           margin-bottom: 1rem;
//         }

//         .loading-state, .error-state {
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           justify-content: center;
//           min-height: 60vh;
//           color: white;
//         }

//         .loading-spinner {
//           width: 50px;
//           height: 50px;
//           border: 4px solid rgba(255, 255, 255, 0.3);
//           border-top-color: white;
//           border-radius: 50%;
//           animation: spin 1s linear infinite;
//         }

//         @keyframes spin {
//           to { transform: rotate(360deg); }
//         }

//         .error-state h4 {
//           color: white;
//           margin-bottom: 1rem;
//         }

//         @media (max-width: 768px) {
//           .dashboard-container {
//             padding: 1rem;
//           }

//           .stats-grid {
//             grid-template-columns: 1fr;
//           }

//           .charts-grid {
//             grid-template-columns: 1fr;
//           }
//         }
//       `}</style>

//       <div className="dashboard-header">
//         <h1 className="dashboard-title">📊 Dashboard Overview</h1>
//       </div>

//       {/* Modern Stats Cards */}
//       <div className="stats-grid">
//         <ModernStatsCard
//           title="Total Posts"
//           value={overview.totalPosts?.toLocaleString() || "0"}
//           percentage={calculatePercentage(
//             todayStats.total,
//             overview.totalPosts
//           )}
//           icon={FiFileText}
//           gradient="linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
//           trend={5.2}
//         />
//         <ModernStatsCard
//           title="Total Visitors"
//           value={overview.totalVisitors?.toLocaleString() || "0"}
//           percentage={calculatePercentage(
//             overview.totalVisitors,
//             overview.totalVisitors * 1.1
//           )}
//           icon={FiEye}
//           gradient="linear-gradient(135deg, #f093fb 0%, #f5576c 100%)"
//           trend={8.5}
//         />
//         <ModernStatsCard
//           title="News Articles"
//           value={overview.totalNews?.toLocaleString() || "0"}
//           percentage={calculatePercentage(
//             todayStats.newsPublished,
//             overview.totalNews
//           )}
//           icon={BiNews}
//           gradient="linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)"
//           trend={3.8}
//         />
//         <ModernStatsCard
//           title="Videos"
//           value={overview.totalVideos?.toLocaleString() || "0"}
//           percentage={calculatePercentage(
//             todayStats.videosPublished,
//             overview.totalVideos
//           )}
//           icon={BiVideo}
//           gradient="linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)"
//           trend={6.1}
//         />
//         <ModernStatsCard
//           title="Top News"
//           value={newsTypes.topNews?.toLocaleString() || "0"}
//           percentage={calculatePercentage(
//             newsTypes.topNews,
//             overview.totalNews
//           )}
//           icon={FiTrendingUp}
//           gradient="linear-gradient(135deg, #fa709a 0%, #fee140 100%)"
//           trend={4.3}
//         />
//         <ModernStatsCard
//           title="Avg Visitors/Post"
//           value={overview.avgVisitorsPerNews?.toFixed(1) || "0"}
//           percentage="2.5"
//           icon={FiUsers}
//           gradient="linear-gradient(135deg, #30cfd0 0%, #330867 100%)"
//           trend={2.5}
//         />
//       </div>

//       {/* Charts Section */}
//       <div className="charts-grid">
//         <div className="glass-card">
//           <SimpleDonutChart
//             data={categoryData}
//             labels={categoryLabels}
//             colors={categoryColors}
//           />
//         </div>

//         <div className="glass-card">
//           <SimpleLineChart
//             title="Daily Visitor Trends"
//             labels={trendLabels}
//             dataPoints={trendVisitors}
//             color="rgb(102, 126, 234)"
//           />
//         </div>

//         <div className="glass-card">
//           <SimpleLineChart
//             title="Daily Posts Published"
//             labels={trendLabels}
//             dataPoints={trendPosts}
//             color="rgb(67, 233, 123)"
//           />
//         </div>
//       </div>

//       {/* Data Tables */}
//       <div className="charts-grid">
//         <ModernTableCard
//           title="🏆 Top Visitor News"
//           data={topVisitorNews.slice(0, 5)}
//           type="news"
//         />
//         <ModernTableCard
//           title="✍️ Top Reporters"
//           data={topReporters.slice(0, 5)}
//           type="reporter"
//         />
//         <ModernTableCard
//           title="📰 Recent News"
//           data={recentPosts.news?.slice(0, 5)}
//           type="news"
//         />
//         <ModernTableCard
//           title="🎥 Recent Videos"
//           data={recentPosts.videos?.slice(0, 5)}
//           type="video"
//         />
//       </div>
//     </div>
//   );
// }

// export default Dashboard;
import React from "react";
import { BiNews, BiVideo, BiTrendingDown } from "react-icons/bi";
import { FiEye, FiTrendingUp, FiUsers, FiFileText } from "react-icons/fi";
import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "../store/api/api";
import useAuthToken from "../Hooks/useAuthToken";

// Modern Stats Card Component
const ModernStatsCard = ({
  title,
  value,
  percentage,
  icon: Icon,
  gradient,
  trend,
}) => (
  <div className="modern-stats-card">
    <div className="stats-icon-wrapper" style={{ background: gradient }}>
      <Icon size={24} />
    </div>
    <div className="stats-content">
      <p className="stats-title">{title}</p>
      <h3 className="stats-value">{value}</h3>
      <div className="stats-footer">
        <span className={`trend ${trend >= 0 ? "trend-up" : "trend-down"}`}>
          {trend >= 0 ? (
            <FiTrendingUp size={14} />
          ) : (
            <BiTrendingDown size={14} />
          )}
          {percentage}%
        </span>
        <span className="stats-period">vs last period</span>
      </div>
    </div>
  </div>
);

// Modern Table Card
const ModernTableCard = ({ title, data, type }) => (
  <div className="glass-card">
    <div className="card-header-modern">
      <h5 className="card-title-modern">{title}</h5>
      <div className="card-badge">{data?.length || 0} items</div>
    </div>
    <div className="table-container-modern">
      {data && data.length > 0 ? (
        <div className="modern-list">
          {data.map((item, index) => (
            <div key={item._id || index} className="modern-list-item">
              <div className="item-index">{index + 1}</div>
              {item.image && (
                <img src={item.image} alt={item.title} className="item-image" />
              )}
              <div className="item-content">
                <h6 className="item-title">
                  {item.title || item.reporterEmail}
                </h6>
                <p className="item-subtitle">
                  {type === "news" &&
                    `${item.visitor?.toLocaleString()} views • ${
                      item.categoryList?.[0]?.name || "News"
                    }`}
                  {type === "video" &&
                    new Date(item.createdAt).toLocaleDateString()}
                  {type === "reporter" &&
                    `${
                      item.postsCount
                    } posts • ${item.totalVisitors?.toLocaleString()} views`}
                </p>
              </div>
              {type === "reporter" && (
                <div className="item-stats">
                  <span className="stat-badge primary">{item.postsCount}</span>
                  <span className="stat-badge success">
                    {Math.round(item.totalVisitors / item.postsCount)}
                  </span>
                </div>
              )}
            </div>
          ))}
        </div>
      ) : (
        <div className="empty-state">
          <FiFileText size={48} />
          <p>No data available</p>
        </div>
      )}
    </div>
  </div>
);

// Simple Line Chart Component
const SimpleLineChart = ({ title, labels, dataPoints, color }) => {
  if (!dataPoints || dataPoints.length === 0) {
    return (
      <div>
        <h5 className="card-title-modern" style={{ marginBottom: "1.5rem" }}>
          {title}
        </h5>
        <div className="empty-state">
          <p>No data available</p>
        </div>
      </div>
    );
  }

  const maxValue = Math.max(...dataPoints);
  const minValue = Math.min(...dataPoints);
  const range = maxValue - minValue || 1;

  return (
    <div>
      <h5 className="card-title-modern" style={{ marginBottom: "1.5rem" }}>
        {title}
      </h5>
      <div style={{ height: "200px", position: "relative" }}>
        <svg width="100%" height="100%" style={{ overflow: "visible" }}>
          <defs>
            <linearGradient
              id={`gradient-${color}`}
              x1="0%"
              y1="0%"
              x2="0%"
              y2="100%"
            >
              <stop
                offset="0%"
                style={{ stopColor: color, stopOpacity: 0.3 }}
              />
              <stop
                offset="100%"
                style={{ stopColor: color, stopOpacity: 0 }}
              />
            </linearGradient>
          </defs>
          <polygon
            fill={`url(#gradient-${color})`}
            points={`0%,100% ${dataPoints
              .map((value, index) => {
                const x = (index / (dataPoints.length - 1)) * 100;
                const y = 100 - ((value - minValue) / range) * 80;
                return `${x}%,${y}%`;
              })
              .join(" ")} 100%,100%`}
          />
          <polyline
            fill="none"
            stroke={color}
            strokeWidth="3"
            points={dataPoints
              .map((value, index) => {
                const x = (index / (dataPoints.length - 1)) * 100;
                const y = 100 - ((value - minValue) / range) * 80;
                return `${x}%,${y}%`;
              })
              .join(" ")}
          />
          {dataPoints.map((value, index) => {
            const x = (index / (dataPoints.length - 1)) * 100;
            const y = 100 - ((value - minValue) / range) * 80;
            return (
              <circle
                key={index}
                cx={`${x}%`}
                cy={`${y}%`}
                r="5"
                fill="white"
                stroke={color}
                strokeWidth="2"
              />
            );
          })}
        </svg>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "1rem",
          fontSize: "0.8rem",
          color: "#718096",
        }}
      >
        {labels.map((label, index) => (
          <span key={index}>{label}</span>
        ))}
      </div>
    </div>
  );
};

// Donut Chart Component
const SimpleDonutChart = ({ data, labels, colors }) => {
  if (!data || data.length === 0) {
    return (
      <div>
        <h5 className="card-title-modern" style={{ marginBottom: "1.5rem" }}>
          Posts by Category
        </h5>
        <div className="empty-state">
          <p>No data available</p>
        </div>
      </div>
    );
  }

  const total = data.reduce((sum, val) => sum + val, 0);
  let currentAngle = -90;

  return (
    <div>
      <h5 className="card-title-modern" style={{ marginBottom: "1.5rem" }}>
        Posts by Category
      </h5>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginBottom: "1.5rem",
        }}
      >
        <svg width="200" height="200" viewBox="0 0 200 200">
          {data.map((value, index) => {
            const percentage = (value / total) * 100;
            const angle = (percentage / 100) * 360;
            const startAngle = currentAngle;
            const endAngle = currentAngle + angle;
            currentAngle = endAngle;

            const startRad = (startAngle * Math.PI) / 180;
            const endRad = (endAngle * Math.PI) / 180;

            const x1 = 100 + 80 * Math.cos(startRad);
            const y1 = 100 + 80 * Math.sin(startRad);
            const x2 = 100 + 80 * Math.cos(endRad);
            const y2 = 100 + 80 * Math.sin(endRad);

            const largeArc = angle > 180 ? 1 : 0;

            return (
              <path
                key={index}
                d={`M 100 100 L ${x1} ${y1} A 80 80 0 ${largeArc} 1 ${x2} ${y2} Z`}
                fill={colors[index % colors.length]}
                style={{
                  transition: "all 0.3s ease",
                  cursor: "pointer",
                }}
              />
            );
          })}
          <circle cx="100" cy="100" r="50" fill="white" />
          <text
            x="100"
            y="95"
            textAnchor="middle"
            fontSize="20"
            fontWeight="bold"
            fill="#2d3748"
          >
            {total}
          </text>
          <text
            x="100"
            y="115"
            textAnchor="middle"
            fontSize="12"
            fill="#718096"
          >
            Total
          </text>
        </svg>
      </div>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "1rem",
          justifyContent: "center",
        }}
      >
        {labels.map((label, index) => (
          <div
            key={index}
            style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
          >
            <div
              style={{
                width: "12px",
                height: "12px",
                borderRadius: "3px",
                backgroundColor: colors[index % colors.length],
              }}
            />
            <span style={{ fontSize: "0.85rem", color: "#4a5568" }}>
              {label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

function Dashboard() {
  const token = useAuthToken();

  // Fetch Dashboard Stats
  const {
    data: dashboardData,
    isLoading: isDashboardLoading,
    error: dashboardError,
  } = useQuery({
    queryKey: ["dashboard-stats"],
    queryFn: () => apiRequest("get", "/api/dashboard/stats", null, token || ""),
    enabled: !!token,
  });

  // Fetch Visitor Trends
  const { data: visitorTrendsData, isLoading: isTrendsLoading } = useQuery({
    queryKey: ["visitor-trends"],
    queryFn: () =>
      apiRequest(
        "get",
        "/api/dashboard/visitor-trends?period=7",
        null,
        token || ""
      ),
    enabled: !!token,
  });

  // Fetch Top Reporters
  const { data: topReportersData, isLoading: isReportersLoading } = useQuery({
    queryKey: ["top-reporters"],
    queryFn: () =>
      apiRequest("get", "/api/dashboard/top-reporters", null, token || ""),
    enabled: !!token,
  });

  // Extract data from responses
  const stats = dashboardData?.data || {};
  const overview = stats?.overview || {};
  const todayStats = stats?.todayStats || {};
  const newsTypes = stats?.newsTypes || {};
  const topVisitorNews = stats?.topVisitorNews || [];
  const recentPosts = stats?.recentPosts || {};
  const categoryWiseCount = stats?.categoryWiseCount || [];

  const visitorTrends = visitorTrendsData?.data || [];
  const topReporters = topReportersData?.data || [];

  // Prepare data for charts
  const trendLabels = visitorTrends.map((item) => {
    const date = new Date(item.date);
    return date.toLocaleDateString("en-US", { month: "short", day: "numeric" });
  });
  const trendVisitors = visitorTrends.map((item) => item.totalVisitors);
  const trendPosts = visitorTrends.map((item) => item.postsCount);

  // Category Chart Data
  const categoryLabels = categoryWiseCount.map((item) => item.categoryName);
  const categoryData = categoryWiseCount.map((item) => item.count);
  const categoryColors = [
    "#667eea",
    "#764ba2",
    "#f093fb",
    "#4facfe",
    "#00f2fe",
    "#43e97b",
    "#fa709a",
    "#fee140",
  ];

  // Calculate percentage
  const calculatePercentage = (current, total) => {
    if (!total) return "0";
    return ((current / total) * 100).toFixed(1);
  };

  if (isDashboardLoading || isTrendsLoading || isReportersLoading) {
    return (
      <div className="modern-loading-container">
        <style>{`
          .modern-loading-container {
            min-height: 100vh;
            background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 2rem;
          }

          .loading-card {
            background: white;
            padding: 3rem 4rem;
            border-radius: 30px;
            box-shadow: 0 20px 60px rgba(0,0,0,0.08);
            text-align: center;
            border: 1px solid #e9ecef;
            animation: fadeInUp 0.6s ease;
          }

          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(30px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          .modern-spinner {
            width: 80px;
            height: 80px;
            margin: 0 auto 2rem;
            position: relative;
          }

          .spinner-circle {
            width: 100%;
            height: 100%;
            border-radius: 50%;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%);
            animation: rotate 1.5s cubic-bezier(0.68, -0.55, 0.265, 1.55) infinite;
            position: relative;
          }

          .spinner-circle::before {
            content: '';
            position: absolute;
            top: 4px;
            left: 4px;
            right: 4px;
            bottom: 4px;
            background: white;
            border-radius: 50%;
          }

          .spinner-circle::after {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 24px;
            height: 24px;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            border-radius: 50%;
            animation: pulse 1.5s ease infinite;
          }

          @keyframes rotate {
            0% {
              transform: rotate(0deg) scale(1);
            }
            50% {
              transform: rotate(180deg) scale(1.1);
            }
            100% {
              transform: rotate(360deg) scale(1);
            }
          }

          @keyframes pulse {
            0%, 100% {
              transform: translate(-50%, -50%) scale(0.8);
              opacity: 0.8;
            }
            50% {
              transform: translate(-50%, -50%) scale(1);
              opacity: 1;
            }
          }

          .loading-text {
            font-size: 1.5rem;
            font-weight: 700;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            margin-bottom: 0.75rem;
            animation: textPulse 2s ease infinite;
          }

          @keyframes textPulse {
            0%, 100% {
              opacity: 0.7;
            }
            50% {
              opacity: 1;
            }
          }

          .loading-subtitle {
            color: #718096;
            font-size: 1rem;
            font-weight: 500;
            margin: 0;
          }

          .loading-dots {
            display: inline-flex;
            gap: 6px;
            margin-left: 4px;
          }

          .loading-dots span {
            width: 6px;
            height: 6px;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            border-radius: 50%;
            animation: dotBounce 1.4s ease infinite;
          }

          .loading-dots span:nth-child(2) {
            animation-delay: 0.2s;
          }

          .loading-dots span:nth-child(3) {
            animation-delay: 0.4s;
          }

          @keyframes dotBounce {
            0%, 80%, 100% {
              transform: translateY(0);
              opacity: 0.5;
            }
            40% {
              transform: translateY(-10px);
              opacity: 1;
            }
          }

          .loading-stats {
            display: flex;
            gap: 2rem;
            justify-content: center;
            margin-top: 2rem;
            padding-top: 2rem;
            border-top: 1px solid #e9ecef;
          }

          .loading-stat {
            text-align: center;
          }

          .loading-stat-icon {
            width: 40px;
            height: 40px;
            margin: 0 auto 0.5rem;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
            font-size: 1.25rem;
            animation: iconFloat 2s ease infinite;
          }

          @keyframes iconFloat {
            0%, 100% {
              transform: translateY(0);
            }
            50% {
              transform: translateY(-5px);
            }
          }

          .loading-stat-label {
            font-size: 0.85rem;
            color: #a0aec0;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.5px;
          }
        `}</style>

        <div className="loading-card">
          <div className="modern-spinner">
            <div className="spinner-circle"></div>
          </div>

          <h2 className="loading-text">Loading Dashboard</h2>
          <p className="loading-subtitle">
            Preparing your data
            <span className="loading-dots">
              <span></span>
              <span></span>
              <span></span>
            </span>
          </p>

          <div className="loading-stats">
            <div className="loading-stat">
              <div className="loading-stat-icon">📊</div>
              <div className="loading-stat-label">Stats</div>
            </div>
            <div className="loading-stat">
              <div className="loading-stat-icon">📈</div>
              <div className="loading-stat-label">Charts</div>
            </div>
            <div className="loading-stat">
              <div className="loading-stat-icon">📰</div>
              <div className="loading-stat-label">News</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (dashboardError) {
    return (
      <div className="dashboard-container">
        <div className="error-state">
          <h4>⚠️ Error loading dashboard</h4>
          <p>{dashboardError.message}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard-container">
      <style>{`
        * {
          box-sizing: border-box;
        }

        .dashboard-container {
          padding: 2rem;
          background: #f8f9fa;
          min-height: 100vh;
        }

        .dashboard-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 2rem;
          background: white;
          padding: 2rem;
          border-radius: 20px;
          box-shadow: 0 2px 20px rgba(0,0,0,0.03);
          border: 1px solid #e9ecef;
        }

        .dashboard-title {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          font-size: 2rem;
          font-weight: 800;
          margin: 0;
        }

        .stats-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 1.5rem;
          margin-bottom: 2rem;
        }

        .modern-stats-card {
          padding: 1.5rem;
          border-radius: 20px;
          background: white;
          box-shadow: 0 2px 20px rgba(0,0,0,0.03);
          border: 1px solid #e9ecef;
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
        }

        .modern-stats-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: linear-gradient(90deg, transparent, rgba(102, 126, 234, 0.5), transparent);
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        .modern-stats-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 12px 40px rgba(102, 126, 234, 0.15);
          border-color: rgba(102, 126, 234, 0.3);
        }

        .modern-stats-card:hover::before {
          opacity: 1;
        }

        .stats-icon-wrapper {
          width: 56px;
          height: 56px;
          border-radius: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          margin-bottom: 1rem;
          box-shadow: 0 4px 20px rgba(102, 126, 234, 0.3);
        }

        .stats-content {
          position: relative;
          z-index: 1;
        }

        .stats-title {
          color: #718096;
          font-size: 0.9rem;
          margin: 0 0 0.5rem 0;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .stats-value {
          color: #2d3748;
          font-size: 2.25rem;
          font-weight: 800;
          margin: 0 0 0.75rem 0;
        }

        .stats-footer {
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }

        .trend {
          display: flex;
          align-items: center;
          gap: 0.25rem;
          padding: 0.35rem 0.85rem;
          border-radius: 20px;
          font-size: 0.85rem;
          font-weight: 700;
        }

        .trend-up {
          background: #d4edda;
          color: #28a745;
        }

        .trend-down {
          background: #f8d7da;
          color: #dc3545;
        }

        .stats-period {
          color: #a0aec0;
          font-size: 0.85rem;
          font-weight: 500;
        }

        .charts-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
          gap: 1.5rem;
          margin-bottom: 2rem;
        }

        .glass-card {
          background: white;
          border-radius: 20px;
          padding: 1.5rem;
          box-shadow: 0 2px 20px rgba(0,0,0,0.03);
          border: 1px solid #e9ecef;
          transition: all 0.3s ease;
        }

        .glass-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 30px rgba(0,0,0,0.08);
          border-color: rgba(102, 126, 234, 0.2);
        }

        .card-header-modern {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 1.5rem;
          padding-bottom: 1rem;
          border-bottom: 2px solid #f0f0f0;
        }

        .card-title-modern {
          font-size: 1.25rem;
          font-weight: 700;
          color: #2d3748;
          margin: 0;
        }

        .card-badge {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          padding: 0.5rem 1rem;
          border-radius: 20px;
          font-size: 0.85rem;
          font-weight: 600;
          box-shadow: 0 2px 10px rgba(102, 126, 234, 0.3);
        }

        .table-container-modern {
          max-height: 400px;
          overflow-y: auto;
        }

        .table-container-modern::-webkit-scrollbar {
          width: 6px;
        }

        .table-container-modern::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 10px;
        }

        .table-container-modern::-webkit-scrollbar-thumb {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border-radius: 10px;
        }

        .modern-list {
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }

        .modern-list-item {
          display: flex;
          align-items: center;
          gap: 1rem;
          padding: 1rem;
          background: #f8f9fa;
          border-radius: 16px;
          transition: all 0.3s ease;
          border: 1px solid transparent;
        }

        .modern-list-item:hover {
          background: white;
          transform: translateX(8px);
          box-shadow: 0 4px 20px rgba(0,0,0,0.06);
          border-color: rgba(102, 126, 234, 0.2);
        }

        .item-index {
          width: 36px;
          height: 36px;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 700;
          font-size: 0.9rem;
          flex-shrink: 0;
          box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
        }

        .item-image {
          width: 64px;
          height: 64px;
          border-radius: 14px;
          object-fit: cover;
          flex-shrink: 0;
          border: 2px solid #e9ecef;
        }

        .item-content {
          flex: 1;
          min-width: 0;
        }

        .item-title {
          font-size: 0.95rem;
          font-weight: 700;
          color: #2d3748;
          margin: 0 0 0.35rem 0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .item-subtitle {
          font-size: 0.85rem;
          color: #718096;
          margin: 0;
          font-weight: 500;
        }

        .item-stats {
          display: flex;
          gap: 0.5rem;
          flex-shrink: 0;
        }

        .stat-badge {
          padding: 0.4rem 0.85rem;
          border-radius: 20px;
          font-size: 0.85rem;
          font-weight: 700;
        }

        .stat-badge.primary {
          background: #e3f2fd;
          color: #1976d2;
        }

        .stat-badge.success {
          background: #e8f5e9;
          color: #388e3c;
        }

        .empty-state {
          text-align: center;
          padding: 3rem;
          color: #a0aec0;
        }

        .empty-state svg {
          color: #cbd5e0;
          margin-bottom: 1rem;
        }

        .empty-state p {
          font-weight: 600;
          font-size: 1rem;
        }

        .loading-state, .error-state {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          min-height: 60vh;
        }

        .error-state h4 {
          color: #2d3748;
          margin-bottom: 1rem;
        }

        @media (max-width: 768px) {
          .dashboard-container {
            padding: 1rem;
          }

          .dashboard-header {
            padding: 1.5rem;
          }

          .dashboard-title {
            font-size: 1.5rem;
          }

          .stats-grid {
            grid-template-columns: 1fr;
          }

          .charts-grid {
            grid-template-columns: 1fr;
          }

          .stats-value {
            font-size: 1.75rem;
          }
        }
      `}</style>

      <div className="dashboard-header">
        <h1 className="dashboard-title">📊 Dashboard Overview</h1>
      </div>

      {/* Modern Stats Cards */}
      <div className="stats-grid">
        <ModernStatsCard
          title="Total Posts"
          value={overview.totalPosts?.toLocaleString() || "0"}
          percentage={calculatePercentage(
            todayStats.total,
            overview.totalPosts
          )}
          icon={FiFileText}
          gradient="linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
          trend={5.2}
        />
        <ModernStatsCard
          title="Total Visitors"
          value={overview.totalVisitors?.toLocaleString() || "0"}
          percentage={calculatePercentage(
            overview.totalVisitors,
            overview.totalVisitors * 1.1
          )}
          icon={FiEye}
          gradient="linear-gradient(135deg, #f093fb 0%, #f5576c 100%)"
          trend={8.5}
        />
        <ModernStatsCard
          title="News Articles"
          value={overview.totalNews?.toLocaleString() || "0"}
          percentage={calculatePercentage(
            todayStats.newsPublished,
            overview.totalNews
          )}
          icon={BiNews}
          gradient="linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)"
          trend={3.8}
        />
        <ModernStatsCard
          title="Videos"
          value={overview.totalVideos?.toLocaleString() || "0"}
          percentage={calculatePercentage(
            todayStats.videosPublished,
            overview.totalVideos
          )}
          icon={BiVideo}
          gradient="linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)"
          trend={6.1}
        />
        <ModernStatsCard
          title="Top News"
          value={newsTypes.topNews?.toLocaleString() || "0"}
          percentage={calculatePercentage(
            newsTypes.topNews,
            overview.totalNews
          )}
          icon={FiTrendingUp}
          gradient="linear-gradient(135deg, #fa709a 0%, #fee140 100%)"
          trend={4.3}
        />
        <ModernStatsCard
          title="Avg Visitors/Post"
          value={overview.avgVisitorsPerNews?.toFixed(1) || "0"}
          percentage="2.5"
          icon={FiUsers}
          gradient="linear-gradient(135deg, #30cfd0 0%, #330867 100%)"
          trend={2.5}
        />
      </div>

      {/* Charts Section */}
      <div className="charts-grid">
        <div className="glass-card">
          <SimpleDonutChart
            data={categoryData}
            labels={categoryLabels}
            colors={categoryColors}
          />
        </div>

        <div className="glass-card">
          <SimpleLineChart
            title="Daily Visitor Trends"
            labels={trendLabels}
            dataPoints={trendVisitors}
            color="rgb(102, 126, 234)"
          />
        </div>

        <div className="glass-card">
          <SimpleLineChart
            title="Daily Posts Published"
            labels={trendLabels}
            dataPoints={trendPosts}
            color="rgb(67, 233, 123)"
          />
        </div>
      </div>

      {/* Data Tables */}
      <div className="charts-grid">
        <ModernTableCard
          title="🏆 Top Visitor News"
          data={topVisitorNews.slice(0, 5)}
          type="news"
        />
        <ModernTableCard
          title="✍️ Top Reporters"
          data={topReporters.slice(0, 5)}
          type="reporter"
        />
        <ModernTableCard
          title="📰 Recent News"
          data={recentPosts.news?.slice(0, 5)}
          type="news"
        />
        <ModernTableCard
          title="🎥 Recent Videos"
          data={recentPosts.videos?.slice(0, 5)}
          type="video"
        />
      </div>
    </div>
  );
}

export default Dashboard;
